import { useHead } from '@vueuse/head';

type SeoPayload = {
  title: string;
  description: string;
  keywords?: string;
};

export function useSeo(payload: SeoPayload): void {
  const siteName = 'Hyxino 科技门户';
  const fullTitle = /[|｜]/.test(payload.title)
    ? payload.title
    : `${payload.title} | ${siteName}`;

  useHead({
    title: fullTitle,
    meta: [
      { name: 'description', content: payload.description },
      { name: 'keywords', content: payload.keywords ?? '企业门户,数字化,解决方案,品牌官网' },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: payload.description },
      { property: 'og:type', content: 'website' }
    ]
  });
}
